import { FC } from 'react'
import {
  ArrayInput, BooleanInput, Create, NumberInput, SelectInput, SimpleForm,
  SimpleFormIterator, TextInput, required, useTranslate,
} from 'react-admin'
import { Typography } from '@mui/material'
import { ConditionalHeaderValue } from './AuthConfigFields'
import { AUTH_TYPE_CHOICES, VALUE_TYPE_CHOICES } from './headerConstants'

const ApplicationCreate: FC = () => {
  const translate = useTranslate()

  return (
    <Create redirect="show">
      {/* eslint-disable-next-line camelcase */}
      <SimpleForm defaultValues={{ enabled: true, auth_config: {} }}>
        <TextInput source="display_name" label="data.displayName" fullWidth validate={required()} />
        <TextInput source="description" label="data.description" fullWidth multiline />
        <SelectInput
          source="auth_type"
          label="data.authType"
          fullWidth
          validate={required()}
          choices={AUTH_TYPE_CHOICES}
        />
        <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
          {translate('data.environmentAuthHelp')}
        </Typography>
        <Typography variant="subtitle2" color="text.secondary" sx={{ mt: 2, mb: 1 }}>
          {translate('data.customHeadersOptional')}
        </Typography>
        <ArrayInput source="headers" label="">
          <SimpleFormIterator inline disableReordering>
            <TextInput source="header_name" label="data.headerName" validate={required()} />
            <SelectInput
              source="value_type"
              label="data.headerType"
              choices={VALUE_TYPE_CHOICES}
              validate={required()}
            />
            <ConditionalHeaderValue />
            <TextInput source="value_prefix" label="data.headerPrefix" />
          </SimpleFormIterator>
        </ArrayInput>
        <NumberInput
          source="cost_per_1000_calls"
          label="data.costPer1000Calls"
          defaultValue={0}
          min={0}
          step={0.001}
          fullWidth
        />
        <BooleanInput source="enabled" label="data.enabled" />
      </SimpleForm>
    </Create>
  )
}

export default ApplicationCreate
